import { Box, FormControl, FormErrorMessage, FormLabel, Select } from '@chakra-ui/react';
import { nodeParser } from '@kontent-ai/delivery-node-parser';
import { createRichTextHtmlResolver } from '@kontent-ai/delivery-sdk';
import { Field } from 'formik';
import { DropdownFormField } from 'models';
import React, { FunctionComponent } from 'react';

import { resolveHtml } from '../../helpers/htmlResolver';
import { getLabelName, validatCheckField } from '../../utils/form/validation';

interface DropdownFieldProps {
  model: DropdownFormField;
}

export const DropdownField: FunctionComponent<DropdownFieldProps> = ({ model }) => {
  return (
    <Field as={Select} name={model.elements.name.value} validate={validatCheckField(model)}>
      {({ field, form }) => (
        <FormControl isInvalid={form.errors[model.elements.name.value] && form.touched[model.elements.name.value]}>
          {model.elements.label.value !== '' && <FormLabel>{getLabelName(model)}</FormLabel>}
          <Select {...field} bg='#FFFFFF' errorBorderColor='#FF8855'>
            {model.elements.dropdownOptions.linkedItems.map((item) => {
              const labelHtml = createRichTextHtmlResolver(nodeParser).resolveRichText({
                element: item.elements.label,
              }).html;
              const dropdown_values = resolveHtml(item.elements.label.value).body;

              return (
                <option key={item.elements.label.value} value={dropdown_values}>
                  <Box dangerouslySetInnerHTML={{ __html: labelHtml }} />
                </option>
              );
            })}
          </Select>
          <FormErrorMessage>{form.errors[model.elements.name.value]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
